import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ExclamationCircle } from 'react-bootstrap-icons';
import "./style.css";
import LoginPopup from '../LoginPopup';

import eye_show from '../../assets/img/icon/eye_show.png';
import eye_hide from '../../assets/img/icon/eye_hide.png';

function Login(props) {
    const [keepLogin, setKeepLogin] = useState(false);
    const [email, setEmail] = useState('');
    const [validationEmail, setValidationEmail] = useState();
    const [password, setPassword] = useState('');
    const [validationPassword, setValidationPassword] = useState();
    const [error, setError] = useState();
    const [loading, setLoading] = useState();
    const [passwordShown, setPasswordShown] = useState(false);
    const [popup, setPopup] = useState(null);
    const [lockUntil, setLockUntil] = useState(0);

    // buka kunci tombol Masuk saat waktu tunggu habis
    useEffect(() => {
        if (!lockUntil) return;
        const sisa = lockUntil - Date.now();
        if (sisa <= 0) { setLockUntil(0); return; }
        const t = setTimeout(() => setLockUntil(0), sisa);
        return () => clearTimeout(t);
    }, [lockUntil]);

    const togglePasswordVisiblity = () => setPasswordShown(!passwordShown);
    const handlerSetKeepLogin = () => setKeepLogin(!keepLogin);

    const doValidation = () => {
        if (lockUntil > Date.now()) return;
        setValidationEmail(false);
        setValidationPassword(false);
        if (email === '' && password === '') {
            setValidationEmail(true);
            setValidationPassword(true);
            setEmail('');
            setPassword('');
        } else if (email === '') {
            setValidationEmail(true);
            setEmail('');
        } else if (password === '') {
            setValidationPassword(true);
            setPassword('');
        } else {
            doLogin();
        }
    };

    const doLogin = () => {
        let data = { email, password, keepLogin };
        setLoading(true);
        setValidationEmail(false);
        setValidationPassword(false);

        fetch("/_api/main/login", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        })
            .then(res => res.json().catch(() => ({})).then(body => ({ status: res.status, body })))
            .then(({ status, body }) => {
                if (body.success) {
                    window.location.href = body.redirect_uri;
                    return;
                }

                // kena cooldown / blokir (HTTP 429)
                if (status === 429 || body.rate_limited) {
                    const detik = parseInt(body.retry_after, 10) || 5;
                    const endAt = Date.now() + detik * 1000;
                    setLockUntil(endAt);
                    setPopup({ type: detik <= 10 ? 'cooldown' : 'block', endAt });
                    setLoading(false);
                    return;
                }

                if (body.error) {
                    setError(body.error.code);
                    // warning di percobaan ke-5 (cadangan: baca juga dari jumlah percobaan)
                    if (body.error.warning || Number(body.error.attempt) === 5) {
                        setPopup({ type: 'warning' });
                    }
                }

                setLoading(false);
            })
            .catch(() => {
                setError(true);
                setLoading(false);
            });
    };

    return (
        <div className="main-container" data-page={props.appName}>
            {popup ? (
                <LoginPopup
                    type={popup.type}
                    endAt={popup.endAt}
                    onClose={() => setPopup(null)}
                    onFinish={() => setPopup({ type: 'done' })}
                />
            ) : null}
            <div className="main-form">
                <form>
                    <div className="mb-2">
                        <label htmlFor="email">Email</label>
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="text"
                            name="email"
                            id="email"
                            placeholder="Masukkan email / username"
                            className={error === 40001 ? "form-control px-3 is-invalid" : "form-control px-3"}
                            required
                        />
                        {validationEmail && (
                            <div className="invalid-feedback d-block">
                                <ExclamationCircle /> Email / username tidak boleh kosong
                            </div>
                        )}
                        {error === 40001 && (
                            <div className="invalid-feedback d-block">
                                <ExclamationCircle size='14' /> Email tidak ditemukan
                            </div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="password">Password</label>
                        <div className="d-flex input-password">
                            <input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type={passwordShown ? "text" : "password"}
                                name="password"
                                id="password"
                                placeholder="Masukkan password"
                                className={error === 40002 ? "form-control px-3 is-invalid" : "form-control px-3"}
                                required
                            />
                            <div className="input-group-append form-control-feedback">
                                <div className="input-group-text toggle-password">
                                    <img
                                        onClick={togglePasswordVisiblity}
                                        className="icon-btn"
                                        alt="eye"
                                        src={passwordShown ? eye_hide : eye_show}
                                        style={{ width: '25px', height: '25px' }}
                                    />
                                </div>
                            </div>
                        </div>
                        {validationPassword && (
                            <div className="invalid-feedback d-block">
                                <ExclamationCircle /> Password tidak boleh kosong
                            </div>
                        )}
                        {error === 40002 && (
                            <div className="invalid-feedback d-block">
                                <ExclamationCircle size='14' /> Password tidak sesuai
                            </div>
                        )}
                    </div>

                    {/* 🔘 Switch Ingat Saya */}
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <div className="switch-container">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={keepLogin}
                                    onChange={handlerSetKeepLogin}
                                />
                                <span className="slider round"></span>
                            </label>
                            <span className="switch-text">Ingat Saya</span>
                        </div>

                        {error && (
                            <div className="forgot-password">
                                <Link className="link" to="/forgot">Lupa password?</Link>
                            </div>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="form-control mb-2"
                        disabled={lockUntil > Date.now()}
                        onClick={(e) => {
                            e.preventDefault();
                            doValidation();
                        }}
                    >
                        {loading ? (
                            <div className="loading-container">
                                <span className="spinner-border text-light loading" role="status"></span> Tunggu sebentar
                            </div>
                        ) : (
                            "Masuk"
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;